"use client"

import "../css/login.css"
import "../css/wa.css"
import { useState, useEffect } from "react"
import { IoClose } from "react-icons/io5"
import { useNavigate } from "react-router-dom"
import axios from "axios"

const SignUp = () => {
  const navigate = useNavigate()

  const [email, setEmail] = useState("")
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [checkPassword, setCheckPassword] = useState("")
  const [selectedFields, setSelectedFields] = useState([])
  const [company, setCompany] = useState("")
  const [workDuration, setWorkDuration] = useState("")
  const [customCompanyInput, setCustomCompanyInput] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [availableFields, setavailableFields] = useState([])
  const [availableCompanies, setavailableCompanies] = useState([])
  const [checked, setChecked] = useState(false)

  const validatePassword = (password) => {
    const minLength = password.length >= 8
    const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(password)
    const hasNumber = /\d/.test(password)
    const hasUpperCase = /[A-Z]/.test(password)

    return {
      isValid: minLength && hasSpecialChar && hasNumber && hasUpperCase,
      errors: {
        minLength,
        hasSpecialChar,
        hasNumber,
        hasUpperCase,
      },
    }
  }

  useEffect(() => {
    const fetchSignupData = async () => {
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/fetchsignupdata`, {})
        console.log(data)
        setavailableFields(data.userCategory)
        setavailableCompanies(data.userCompany)
      } catch (error) {}
    }
    fetchSignupData()
  }, [])

  const handleFieldSelect = (field) => {
    if (selectedFields.includes(field)) {
      setSelectedFields(selectedFields.filter((f) => f !== field))
    } else if (selectedFields.length < 3) {
      setSelectedFields([...selectedFields, field])
    }
  }

  const handleCompanySelect = (companyName) => {
    setCompany(companyName)
  }

  const handleCustomCompanySubmit = () => {
    if (customCompanyInput.trim()) {
      setCompany(customCompanyInput.trim())
      setCustomCompanyInput("")
    }
  }

  const handleFormSubmit = async () => {
    if (
      !email ||
      !username ||
      !password ||
      !checkPassword ||
      selectedFields.length === 0 ||
      !company ||
      !workDuration
    ) {
      setErrorMessage("모든 필드를 올바르게 입력해주세요.")
      return
    }

    const passwordValidation = validatePassword(password)
    if (!passwordValidation.isValid) {
      let errorMsg = "비밀번호는 다음 조건을 만족해야 합니다: "
      if (!passwordValidation.errors.minLength) errorMsg += "8자 이상, "
      if (!passwordValidation.errors.hasSpecialChar) errorMsg += "특수문자 포함, "
      if (!passwordValidation.errors.hasNumber) errorMsg += "숫자 포함, "
      if (!passwordValidation.errors.hasUpperCase) errorMsg += "대문자 포함"
      setErrorMessage(errorMsg)
      return
    }

    if (password !== checkPassword) {
      setErrorMessage("비밀번호가 일치하지 않습니다.")
      return
    }

    setErrorMessage("")
    setIsSubmitting(true)

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          username,
          password,
          category: selectedFields,
          organ: company,
          term: workDuration,
          checked,
        }),
      })

      const result = await response.json()

      if (!response.ok) {
        setErrorMessage(result.message || "회원가입에 실패했습니다.")
      } else {
        window.location.href = "/login"
      }
    } catch (error) {
      setErrorMessage("서버와 통신 중 문제가 발생했습니다.")
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div className="lg-main">
        <h2>회원가입</h2>
        <input
          type="email"
          placeholder="이메일"
          value={email}
          className="lg-main-input"
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="text"
          placeholder="닉네임"
          className="lg-main-input"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <div className="lg-desc" style={{ marginTop: "15px" }}>
          내 분야 선택하기 (최대 3개)
        </div>
        <div className="field-tag-container">
          {availableFields.map((field) => (
            <div
              key={field}
              className={`field-tag ${selectedFields.includes(field) ? "selected" : ""}`}
              onClick={() => handleFieldSelect(field)}
            >
              {field}
            </div>
          ))}
        </div>
        <div className="lg-selected-count">{selectedFields.length}/3 선택됨</div>

        <div className="lg-desc">내 소속 회사 선택하기</div>
        <div className="field-tag-container">
          {availableCompanies.map((companyName) => (
            <div
              key={companyName}
              className={`field-tag ${company === companyName ? "selected" : ""}`}
              onClick={() => handleCompanySelect(companyName)}
            >
              {companyName}
            </div>
          ))}
        </div>

        <div className="custom-company-input">
          <input
            type="text"
            placeholder="직접 입력하기"
            value={customCompanyInput}
            className="lg-main-input"
            onChange={(e) => setCustomCompanyInput(e.target.value)}
          />
          <button
            className="custom-company-button"
            onClick={handleCustomCompanySubmit}
            disabled={!customCompanyInput.trim()}
          >
            추가
          </button>
        </div>

        {company && (
          <div className="company-selected">
            선택된 회사: <span>{company}</span>
            <button onClick={() => setCompany("")} className="company-remove-btn">
              <IoClose />
            </button>
          </div>
        )}

        <input
          type="number"
          placeholder="내 종사 기간 (년)"
          value={workDuration}
          className="lg-main-input"
          onChange={(e) => setWorkDuration(e.target.value)}
        />
        <input
          type="password"
          placeholder="비밀번호"
          value={password}
          className="lg-main-input"
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className="password-requirements" style={{ fontSize: "12px", color: "#666", margin: "5px 0 15px" }}>
          비밀번호는 8자 이상, 특수문자, 숫자, 대문자를 포함해야 합니다.
        </div>
        <input
          type="password"
          placeholder="비밀번호 확인"
          value={checkPassword}
          className="lg-main-input"
          onChange={(e) => setCheckPassword(e.target.value)}
        />

        <input
          type="checkbox"
          id="myCheckbox"
          checked={checked}
          onChange={() => setChecked(!checked)}
          style={{ marginBottom: 25 }}
        />
        <label htmlFor="myCheckbox">뉴스레터 수신하기</label>

        {errorMessage && <div className="lg-error-message">{errorMessage}</div>}
        <button className="lg-main-button" onClick={handleFormSubmit} disabled={isSubmitting}>
          {isSubmitting ? "처리 중..." : "가입하기"}
        </button>

        <div className="lg-bottom">
          <a href="/login">로그인하기</a>
        </div>
      </div>
    </div>
  )
}

export default SignUp

